import "bootstrap/dist/css/bootstrap.min.css";
import "font-awesome/css/font-awesome.min.css";
import Cookies from "js-cookie";
import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import useGetData from "../StoreComponents/hooks/useGetData";

const StoreSidebar = () => {
  const logInStatus = parseInt(Cookies.get("Role"));
  const location = useLocation();
  const pathname = location.pathname;
  const [hrOpen, setHrOpen] = useState(false);
  const [employeesOpen, setEmployeesOpen] = useState(false);
  const [settingsOpen, setSettingsOpen] = useState(false);

  const toggleHr = () => setHrOpen(!hrOpen);
  const toggleEmployees = () => setEmployeesOpen(!employeesOpen);
  const toggleSettings = () => setSettingsOpen(!settingsOpen);

  const allEmployeeHandler = () => {
    if (pathname === "/allemployees") {
      window.location.reload();
      window.sessionStorage.removeItem("search_All");
      window.sessionStorage.removeItem("user_name");
    }
  };
  // console.log(logInStatus)

  const { CountData } = useGetData();
  const { data: totalRequisitionData } = CountData();
  // console.log(totalRequisitionData);
  return (
    <div className="sidebar" id="sidebar">
      <div className="sidebar-inner overflow-auto">
        <div id="sidebar-menu" className="sidebar-menu">
          <ul>

            {/* <li >
              <a href="/">
                <i className="la la-home" /> <span>Home</span>
              </a>
            </li> */}
            <li>
              <Link to="/">
                <i className="la la-dashboard" />{" "}
                <span style={{ fontSize: "18px" }}> Dashboard</span>
              </Link>
            </li>

            {/* HR and Settings Section from sidebar.jsx */}
            {(logInStatus === 1 || logInStatus === 2) && (
              <>

                {/* HR Section */}
                <li className="submenu text-start">
                  <a
                    href="#"
                    onClick={toggleHr}
                    className={hrOpen ? "active noti-dot" : ""}
                  >
                    <i className="la la-user" /> <span> HR</span>
                    <span className="menu-arrow" />
                  </a>
                  <ul style={{ display: hrOpen ? "block" : "none" }}>
                    {/* Employees Submenu */}
                    <li>
                      <Link
                        to="/hr/admindashboard"
                        className={
                          pathname.includes("/hr/admindashboard") ? "active" : ""
                        }
                      >
                        <i className="la la-dashboard me-3" /> Dashboard
                      </Link>
                    </li>
                    <li className="submenu text-start">
                      <a href="#" onClick={toggleEmployees}>
                        <i className="la la-user me-2 fs-6" />
                        <span> Employees</span>
                        <span className="menu-arrow" />
                      </a>
                      <ul style={{ display: employeesOpen ? "block" : "none" }}>
                        <li>
                          <Link
                            to="/hr/allemployees"
                            className={
                              pathname.includes("/hr/allemployees") ? "active" : ""
                            }
                          >
                            <span onClick={allEmployeeHandler}>
                              <i
                                className="fa fa-user fs-6"
                                aria-hidden="true"
                              ></i>{" "}
                              Employees
                            </span>
                          </Link>
                        </li>
                      </ul>
                    </li>
                    {/* Settings Submenu */}
                    <li className="submenu text-start">
                      <a href="#" onClick={toggleSettings}>
                        <i className="la la-cog me-2 fs-6" />
                        <span> Settings</span>
                        <span className="menu-arrow" />
                      </a>
                      <ul style={{ display: settingsOpen ? "block" : "none" }}>
                        <li>
                          <Link
                            to="/hr/allrole"
                            className={
                              pathname.includes("/hr/allrole") ? "active noti-dot" : ""
                            }
                          >
                            Roles
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/hr/usersadd"
                            className={
                              pathname.includes("/hr/users") ? "active noti-dot" : ""
                            }
                          >
                            Users
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/hr/signature"
                            className={
                              pathname.includes("/hr/signature") ? "active noti-dot" : ""
                            }
                          >
                            Signature
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/hr/department"
                            className={
                              pathname.includes("/hr/department") ? "active noti-dot" : ""
                            }
                          >
                            Departments
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/hr/designation"
                            className={
                              pathname.includes("/hr/designation") ? "active noti-dot" : ""
                            }
                          >
                            Designation
                          </Link>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </>
            )}

            {logInStatus != 5 && logInStatus != 24 && logInStatus != 41 && logInStatus != 2 ? (
              <>
                <li>
                  <Link to="/requisition/create">
                    <i className="la la-edit me-1" />
                    <span style={{ fontSize: "18px" }}> New Requisition</span>
                  </Link>
                </li>
                <li>
                  <Link to="/requisition/view">
                    <i className="la la-gears" />
                    <span style={{ fontSize: "18px" }}>View Requisition</span>
                  </Link>
                </li>

                <li>
                  <Link to="/requisition/userReport">
                    <i class="la la-bar-chart" />
                    <span style={{ fontSize: "18px" }}>User Report</span>
                  </Link>
                </li>
                <li>
                  <Link to="/requisition/productWiseReport">
                    <i class="la la-bar-chart me-1" />
                    <span style={{ fontSize: "18px" }}>
                      Product Wise Report
                    </span>
                  </Link>
                </li>
                <li>
                  <Link to="/requisition/requestProduct/user">
                    <i className="la la-edit me-1" />
                    <span style={{ fontSize: "18px" }}>Request Product</span>
                  </Link>
                </li>
              </>
            ) : (
              ""
            )}

            {logInStatus === 24 || logInStatus === 41 || logInStatus === 2 ? (
              <li className="submenu text-start ">
                <a href="">
                  <i className="fa fa-store fs-5 ms-1" />{" "}
                  <span style={{ fontSize: "18px" }}> Products</span>{" "}
                  <span className="menu-arrow" />
                </a>
                <ul style={{ display: "none" }}>
                  {logInStatus === 24 || logInStatus === 41 || logInStatus === 2 ? (
                    <>
                      <li>
                        <Link to="/product/addNew">
                          <i className="fa fa-hand-o-right fs-6"></i>{" "}
                          <span style={{ fontSize: "18px" }}> New Entry</span>
                        </Link>
                      </li>

                      <li>
                        <Link to="/product/addExisting">
                          <i className="fa fa-hand-o-right fs-6"></i>{" "}
                          <span style={{ fontSize: "18px" }}>
                            {" "}
                            Existing Entry
                          </span>
                        </Link>
                      </li>
                    </>
                  ) : (
                    ""
                  )}

                  <li>
                    <Link to="/product/manageProducts">
                      <i className="fa fa-hand-o-right fs-6"></i>{" "}
                      <span style={{ fontSize: "18px" }}> Stock Product</span>
                    </Link>
                  </li>
                  {/* {logInStatus === 24 || logInStatus === 41 ? (
                    <>
                      <li>
                        <Link to="/projectassetentry">
                          <i className="fa fa-hand-o-right fs-6"></i>{" "}
                          <span style={{ fontSize: "18px" }}>
                            {" "}
                            Project Asset Entry
                          </span>
                        </Link>
                      </li>
                      <li>
                        <Link to="/projectassetmanage">
                          <i className="fa fa-hand-o-right fs-6"></i>{" "}
                          <span style={{ fontSize: "18px" }}>
                            {" "}
                            Project Asset Manage
                          </span>
                        </Link>
                      </li>
                    </>
                  ) : (
                    ""
                  )} */}
                </ul>
              </li>
            ) : (
              ""
            )}

            {logInStatus === 5 || logInStatus === 24 || logInStatus === 41 || logInStatus === 2 ? (
              <li className="submenu text-start">
                <a href="">
                  <i className="la la-newspaper" />{" "}
                  <span style={{ fontSize: "18px" }}>
                    {" "}
                    Requisitions
                    {totalRequisitionData ? (
                      <span
                        className="bg-info text-white px-1 py-1 rounded-3 "
                        style={{ fontSize: "16px" }}
                      >
                        {totalRequisitionData?.TOTALREQUISITION}
                      </span>
                    ) : (
                      ""
                    )}
                  </span>{" "}
                  <span className="menu-arrow" />
                </a>
                <ul id="requisitions" style={{ display: "none" }}>
                  <li>
                    <Link to="/requisitions/pending">
                      <i className="fa fa-hand-o-right fs-6"></i>{" "}
                      <span style={{ fontSize: "18px" }}>
                        Pending
                        {totalRequisitionData ? (
                          <span
                            className="bg-warning text-white px-2 py-1 rounded-3 ms-2"
                            style={{ fontSize: "16px" }}
                          >
                            {totalRequisitionData?.PENDINGCOUNT}
                          </span>
                        ) : (
                          ""
                        )}
                      </span>
                    </Link>
                  </li>

                  <li>
                    <Link to="/requisitions/approved">
                      <i className="fa fa-hand-o-right fs-6"></i>{" "}
                      <span style={{ fontSize: "18px" }}>
                        Approved
                        {totalRequisitionData ? (
                          <span
                            className="bg-success text-white px-2 py-1 rounded-3 ms-2"
                            style={{ fontSize: "16px" }}
                          >
                            {totalRequisitionData?.APPROVEDCOUNT}
                          </span>
                        ) : (
                          ""
                        )}
                      </span>
                    </Link>
                  </li>

                  <li>
                    <Link to="/requisitions/done">
                      <i className="fa fa-hand-o-right fs-6"></i>{" "}
                      <span style={{ fontSize: "18px" }}>
                        Delivered
                        {totalRequisitionData ? (
                          <span
                            className="bg-success text-white px-2 py-1 rounded-3 ms-2"
                            style={{ fontSize: "16px" }}
                          >
                            {totalRequisitionData?.DONECOUNT}
                          </span>
                        ) : (
                          ""
                        )}
                      </span>
                    </Link>
                  </li>

                  <li>
                    <Link to="/requisitions/denied">
                      <i className="fa fa-hand-o-right fs-6"></i>{" "}
                      <span style={{ fontSize: "18px" }}>Denied</span>
                    </Link>
                  </li>
                  {(logInStatus === 24 || logInStatus === 41 || logInStatus === 2) && (
                    <li>
                      <Link to="/requisitions/manual">
                        <i className="fa fa-hand-o-right fs-6"></i>{" "}
                        <span style={{ fontSize: "18px" }}>Manual</span>
                      </Link>
                    </li>
                  )}
                  {(logInStatus === 24 || logInStatus === 41 || logInStatus === 2) && (
                    <li>
                      <Link to="/requisitions/notgiven">
                        <i className="fa fa-hand-o-right fs-6"></i>{" "}
                        <span style={{ fontSize: "18px" }}>
                          Not Given
                          {totalRequisitionData ? (
                            <span
                              className="bg-danger text-white px-2 py-1 rounded-3 ms-2"
                              style={{ fontSize: "16px" }}
                            >
                              {totalRequisitionData?.NOTGIVENCOUNT}
                            </span>
                          ) : (
                            ""
                          )}
                        </span>
                      </Link>
                    </li>
                  )}
                </ul>
              </li>
            ) : (
              ""
            )}

            {logInStatus === 5 || logInStatus === 24 || logInStatus === 41 || logInStatus === 2 ? (
              <li>
                <Link to="/manageSupplier">
                  <i class="ms-1 fa fa-book fs-5 " />{" "}
                  <span style={{ fontSize: "18px" }}> MRR</span>
                </Link>
              </li>
            ) : (
              ""
            )}
            {/* {
  logInStatus!==5 || logInStatus!==24 ?
  <li> 
   <Link to="/reports/requisitions/datewise">
    <i className='fa-regular fa-circle fs-6'></i> <span>Report</span>
  </Link>
</li>
:""
}
  */}

            {logInStatus === 5 ? (
              <li>
                <Link to="/product/manageProducts">
                  <i className="fa fa-store fs-5 ms-1"></i>{" "}
                  <span style={{ fontSize: "18px" }}> Store Product</span>
                </Link>
              </li>
            ) : (
              ""
            )}

            {/* Product Report Menu */}

            {logInStatus === 5 || logInStatus === 24 || logInStatus === 41 || logInStatus === 2 ? (
              <li className="submenu text-start">
                <a href="">
                  <i className="la la-line-chart" />{" "}
                  <span style={{ fontSize: "18px" }}>Product Reports</span>{" "}
                  <span className="menu-arrow" />
                </a>
                <ul style={{ display: "none" }}>
                  <li>
                    <li className="submenu text-start">
                      <a href="">
                        <i className="fa fa-hand-o-right fs-6" />{" "}
                        <span style={{ fontSize: "18px" }}>Entries</span>{" "}
                        <span className="menu-arrow" />
                      </a>
                      <ul style={{ display: "none" }}>
                        <li>
                          <Link to="/reports/entries/allproduct">
                            <i className="fa-regular fa-circle fs-6"></i>{" "}
                            <span style={{ fontSize: "18px" }}>
                              All Product
                            </span>
                          </Link>
                        </li>

                        <li>
                          <Link to="/reports/entries/singleproduct">
                            <i className="fa-regular fa-circle fs-6"></i>{" "}
                            <span style={{ fontSize: "18px" }}>
                              Single Product
                            </span>
                          </Link>
                        </li>
                      </ul>
                    </li>
                  </li>
                  <li>
                    <li className="submenu text-start">
                      <a href="">
                        <i className="fa fa-hand-o-right fs-6" />{" "}
                        <span style={{ fontSize: "18px" }}>Requisitions</span>{" "}
                        <span className="menu-arrow" />
                      </a>
                      <ul style={{ display: "none" }}>
                        <li>
                          <Link to="/reports/requisitions/datewise">
                            <i className="fa-regular fa-circle fs-6"></i>{" "}
                            <span style={{ fontSize: "18px" }}>Date wise</span>
                          </Link>
                        </li>

                        <li>
                          <Link to="/reports/requisitions/productwise">
                            <i className="fa-regular fa-circle fs-6"></i>{" "}
                            <span style={{ fontSize: "18px" }}>
                              Product wise
                            </span>
                          </Link>
                        </li>
                        <li>
                          <Link to="/reports/requisitions/productdatewise">
                            <i className="fa-regular fa-circle fs-6"></i>{" "}
                            <span style={{ fontSize: "18px" }}>
                              Product & Date
                            </span>
                          </Link>
                        </li>
                        <li>
                          <Link to="/reports/requisitions/personwise">
                            <i className="fa-regular fa-circle fs-6"></i>{" "}
                            <span style={{ fontSize: "18px" }}>
                              Person Wise
                            </span>
                          </Link>
                        </li>
                        <li>
                          <Link to="/reports/requisitions/persondatewise">
                            <i className="fa-regular fa-circle fs-6"></i>{" "}
                            <span style={{ fontSize: "18px" }}>
                              Person & Date
                            </span>
                          </Link>
                        </li>
                      </ul>
                    </li>
                  </li>
                  <li>
                    <li className="submenu text-start">
                      <a href="">
                        <i className="fa fa-hand-o-right fs-6" />{" "}
                        <span style={{ fontSize: "18px" }}>Logs</span>{" "}
                        <span className="menu-arrow" />
                      </a>
                      <ul style={{ display: "none" }}>
                        <li>
                          <Link to="/reports/logs/product">
                            <i className="fa-regular fa-circle fs-6"></i>{" "}
                            <span style={{ fontSize: "18px" }}>
                              Product Wise
                            </span>
                          </Link>
                        </li>

                        <li>
                          <Link to="/reports/logs/monthly">
                            <i className="fa-regular fa-circle fs-6"></i>{" "}
                            <span style={{ fontSize: "18px" }}>Month wise</span>
                          </Link>
                        </li>
                        <li>
                          <Link to="/reports/logs/category">
                            <i className="fa-regular fa-circle fs-6"></i>{" "}
                            <span style={{ fontSize: "18px" }}>
                              Category Wise
                            </span>
                          </Link>
                        </li>
                      </ul>
                    </li>
                  </li>
                  <li>
                    <li className="submenu text-start">
                      <a href="">
                        <i className="fa fa-hand-o-right fs-6" />{" "}
                        <span style={{ fontSize: "18px" }}>Stock Status</span>{" "}
                        <span className="menu-arrow" />
                      </a>
                      <ul style={{ display: "none" }}>
                        <li>
                          <Link to="/reports/stockStatus/all">
                            <i className="fa-regular fa-circle fs-6"></i>{" "}
                            <span style={{ fontSize: "18px" }}>
                              All Products
                            </span>
                          </Link>
                        </li>
                        <li>
                          <Link to="/reports/stockStatus/category">
                            <i className="fa-regular fa-circle fs-6"></i>{" "}
                            <span style={{ fontSize: "18px" }}>
                              Category Wise
                            </span>
                          </Link>
                        </li>
                      </ul>
                    </li>
                  </li>
                </ul>
              </li>
            ) : (
              ""
            )}

            {/* Settings Menu */}
            {logInStatus === 24 || logInStatus === 41 || logInStatus === 2 ? (
              <li className="submenu text-start">
                <a href="">
                  <i className="la la-cog" />{" "}
                  <span style={{ fontSize: "18px" }}> Settings</span>{" "}
                  <span className="menu-arrow" />
                </a>
                <ul id="settings" style={{ display: "none" }}>
                  <li>
                    <Link to="/settings/categories">
                      <i className="fa fa-hand-o-right fs-6"></i>{" "}
                      <span style={{ fontSize: "18px" }}> Categories</span>
                    </Link>
                  </li>

                  <li>
                    <Link to="/settings/unit">
                      <i className="fa fa-hand-o-right fs-6"></i>{" "}
                      <span style={{ fontSize: "18px" }}> Unit</span>
                    </Link>
                  </li>

                  <li>
                    <Link to="/settings/suppliers">
                      <i className="fa fa-hand-o-right fs-6"></i>{" "}
                      <span style={{ fontSize: "18px" }}> Suppliers</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/settings/productList">
                      <i className="fa fa-hand-o-right fs-6"></i>{" "}
                      <span style={{ fontSize: "18px" }}> Product List</span>
                    </Link>
                  </li>
                </ul>
              </li>
            ) : (
              ""
            )}

            {logInStatus === 24 || logInStatus === 2 ? (
              <>
                <li className="submenu text-start">
                  <a href="">
                    <i class="fa fa-user-secret fs-5 ms-1"></i>
                    <span style={{ fontSize: "18px" }}>System Access</span>
                    <span className="menu-arrow" />
                  </a>
                  <ul id="access" style={{ display: "none" }}>
                    <li>
                      <Link to="/systemaccess/userprofile">
                        <i className="fa fa-hand-o-right fs-6" />{" "}
                        <span style={{ fontSize: "18px" }}> User Profile</span>
                      </Link>
                    </li>
                    {/* <li>
                      <Link to="/systemaccess/signatureAdd">
                        <i className="fa fa-hand-o-right fs-6" />{" "}
                        <span style={{ fontSize: "18px" }}>Signature Add</span>
                      </Link>
                    </li> */}
                  </ul>
                </li>
              </>
            ) : (
              ""
            )}
            {/* {logInStatus === 5  ? (
              <li>
                <Link to="/roleSet">
                  <i className="fa fa-hand-o-right"></i>{" "}
                  <span style={{ fontSize: "18px" }}> Role Manage</span>
                </Link>
              </li>
            ) : (
              ""
            )} */}
            {logInStatus === 5 || logInStatus === 24 || logInStatus === 2 ? (
              <li>
                <Link to="/requisition/requestProduct">
                  <i
                    class="fa fa-list-check me-1"
                    style={{ fontSize: "18px" }}
                  ></i>

                  <span style={{ fontSize: "18px" }}>Request Product</span>
                </Link>
              </li>
            ) : (
              ""
            )}

            {logInStatus === 5 || logInStatus === 24 || logInStatus === 41 || logInStatus === 2 ? (
              <li className="submenu text-start">
                <a href="">
                  <i className="la la-newspaper" />{" "}
                  <span style={{ fontSize: "18px" }}>My Requisition</span>
                  <span className="menu-arrow" />
                </a>
                <ul id="myrequisition" style={{ display: "none" }}>
                  <li>
                    <Link to="/requisition/create">
                      <i className="la la-edit me-1" />{" "}
                      <span style={{ fontSize: "18px" }}> New Requisition</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/requisition/view">
                      <i className="la la-gears me-1" />
                      <span style={{ fontSize: "18px" }}>View Requisition</span>
                    </Link>
                  </li>

                  <li>
                    <Link to="/requisition/userReport">
                      <i class="la la-bar-chart me-1" />
                      <span style={{ fontSize: "18px" }}>User Report</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/requisition/productWiseReport">
                      <i class="la la-bar-chart me-1" />
                      <span style={{ fontSize: "18px" }}>
                        Product Wise Report
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/requisition/requestProduct/user">
                      <i className="la la-edit me-1" />
                      <span style={{ fontSize: "18px" }}>Request Product</span>
                    </Link>
                  </li>
                </ul>
              </li>
            ) : (
              ""
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default StoreSidebar;
